import FaqPage from '@/components/feature/FaqPage';

export default function BpQ1Page() {
  return (
    <FaqPage
      category="Billing & Payments"
      categoryPath="/"
      icon="ri-refund-2-line"
      title="Where is my refund?"
      intro="Track your refund request and understand processing timelines. Here's everything you need to know about how and when refunds are issued."
      sections={[
        {
          heading: 'How long does a refund take?',
          content: [
            'Once a refund has been approved, it typically takes 5–10 business days to appear on your original payment method. The exact timing depends on your bank or card issuer.',
            'You will receive an email confirmation when your refund has been processed on our end.',
          ],
        },
        {
          heading: 'How do I check the status of my refund?',
          content: [
            'Log in to your account and navigate to Account Settings > Billing History. Any approved refunds will be listed there with their current status.',
            'If you submitted a refund request via our support team, you can also check the status by replying to your original support ticket.',
          ],
        },
        {
          heading: 'I was told my refund was issued but I haven\'t received it',
          content: [
            'If more than 10 business days have passed since your refund was confirmed, please first check with your bank or card issuer — sometimes refunds can take longer to post depending on the institution.',
            'If your bank confirms no refund has been received, please contact our support team with your refund confirmation email and we will investigate immediately.',
          ],
        },
        {
          heading: 'Can I request a refund if I\'m not satisfied?',
          content: [
            'Refund eligibility depends on the terms of your purchase. Please review our refund policy or contact our support team to discuss your specific situation. We aim to resolve all cases fairly.',
          ],
        },
      ]}
    />
  );
}
